import type { TagCatalogRow } from "../api/generated/model";
import { inPalette } from "./tagColor";

// C46 · «Copiar para pegar en Excel» (Etiquetas R2, J1): un solo formateador para el ⋮ de la tabla (lo filtrado) y para
// la barra de selección (lo marcado). Lo copiado se lee como la pantalla, en el idioma de la persona: el color por su
// nombre de C15, la fecha dd/mm/aaaa (en-US mm/dd/yyyy) y el estado en palabras; nunca hex, fechas ISO ni claves
// en inglés (E86). Las cantidades van sin separador de miles para que Excel las sume (única diferencia con la pantalla).

/** Textos de la interfaz con la clave sin el prefijo E1_ (los mismos que usa la pantalla). */
type Texts = (key: string) => string;

/** Una celda: sin tabulaciones ni saltos de línea, que partirían la fila o la columna al pegar. */
const cell = (value: string) => value.replace(/[\t\r\n]+/g, " ").trim();

/** dd/mm/aaaa (en-US mm/dd/yyyy) en la hora local, la misma fecha que muestra la tabla. */
export function clipboardDate(iso: string, locale: string): string {
  const value = new Date(iso);
  const day = String(value.getDate()).padStart(2, "0");
  const month = String(value.getMonth() + 1).padStart(2, "0");
  return locale.toLowerCase().startsWith("en")
    ? `${month}/${day}/${value.getFullYear()}`
    : `${day}/${month}/${value.getFullYear()}`;
}

/** El nombre del color en C15; un color anterior a la paleta se nombra por su equivalente (inPalette, como la etiqueta). */
export function colorName(color: string | null | undefined, L: Texts): string {
  const option = inPalette(color);
  return option ? L(option.label) : "";
}

/** Texto para el portapapeles: títulos y una fila por etiqueta, \t entre celdas y \n entre filas. */
export function tagClipboardText(rows: TagCatalogRow[], L: Texts, locale: string): string {
  const titles = [L("NAME"), L("COLOR"), L("DESCRIPTION"), L("CONTACTS"), L("CREATED"), L("R2_STATUS")];
  const lines = rows.map((row) =>
    [
      row.tag.name,
      colorName(row.tag.color, L),
      row.tag.description ?? "",
      row.contacts === null || row.contacts === undefined ? "" : String(row.contacts),
      clipboardDate(row.tag.createdAt, locale),
      row.tag.archived ? L("R1_ARCHIVED_TAG") : L("R2_ACTIVE_TAG"),
    ].map(cell),
  );
  return [titles.map(cell), ...lines].map((line) => line.join("\t")).join("\n");
}
